module.exports = __webpack_public_path__ + "resources/4ecdb5886bf7f71b67b26b7acaa68653.ttf";


//////////////////
// WEBPACK FOOTER
// ./resources/fonts/Compacta-Bd-BT-Bold.ttf
// module id = 238
// module chunks = 0